import { styles } from 'consts';
import styled from 'styled-components';

const { fontMontserrat, fontMBank, paymentColor, paymentDescription } = styles;

interface IProps {
  isSelected: boolean;
  preSelected?: boolean;
  hasForm?: boolean;
  hasMethodPromotion?: boolean;
  isMobile?: boolean;
}

const borderValue = '0.125rem';
const nestedBorderRadiusValue = '.4rem';

const setNestedPadding = ({ isSelected }: IProps) =>
  isSelected ? `calc(1rem - ${borderValue}) calc(.5rem - ${borderValue})` : `1rem 0.5rem`;
const setNestedBorderRadius = ({ hasForm, isSelected }: IProps) =>
  hasForm && isSelected ? `${nestedBorderRadiusValue} ${nestedBorderRadiusValue} 0 0` : nestedBorderRadiusValue;

const setSelectedColor = ({ isSelected }: IProps) => (isSelected ? '#fff' : '#fbfbfb');

export const CardWLGroupedItemContainer = styled.div<IProps>`
  display: flex;
  width: 100%;
  background-color: ${setSelectedColor};
  border-radius: ${setNestedBorderRadius};
  box-sizing: border-box;
  padding: ${setNestedPadding};
  align-items: center;
  flex-direction: row;
`;

export const CardWLGroupedItemDescription = styled.div`
  color: ${paymentDescription};
  height: 1.25rem;
  font-family: ${fontMontserrat};
  font-size: 0.75rem;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 2;
  letter-spacing: normal;
  margin-right: 4.25rem;

  @media (min-width: 768px) and (max-width: 940px), (max-width: 450px) {
    padding-top: 0.3rem;
    line-height: 1.3;
    height: 1.5rem;
  }

  @media (max-width: 768px) {
    margin-right: 0.25rem;
  }
`;

export const CardWLGroupedItemTitle = styled.div`
  white-space: nowrap;
  width: 100%;
  height: 1.5rem;
  font-size: 1.175rem;
  font-family: ${fontMBank};
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.35;
  letter-spacing: normal;
  color: ${paymentColor};
`;

export const CardWLGroupedItemContent = styled.div`
  display: flex;
  padding: 0 0.5rem;
  width: 100%;
  flex-direction: column;
`;

export const CardWLGroupedItemPaymentIcon = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 40%;
  top: 0.5rem;
  right: 0.5rem;

  &.card-wl-grouped-payment-icon__2005 img {
    height: 3.3125rem;
    width: 7.25rem;
  }

  &.card-wl-grouped-payment-icon__2002 img {
    height: 3.3125rem;
    width: 4.25rem;
    margin-right: 0.25rem;
  }
`;
